export default "__VITE_ASSET__JWz2Kcol__"